__webpack_require__.p = "/widget-terms-data/referrals/";